import React from "react";
import LazyLoad from "react-lazyload";
import {
  Card,
  CardMedia,
  CardContent,
  Typography,
  CardActionArea,
  Button,
  Box,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { format } from "date-fns";

const BlogCard = React.memo(({ blog }) => {
  const navigate = useNavigate();

  const formattedDate = format(new Date(blog.date), "MMMM d, yyyy");

  // Function to strip HTML tags and get clean text for preview
  const stripHtmlTags = (html) => {
    if (!html) return "";
    const tmp = document.createElement("div");
    tmp.innerHTML = html;
    return tmp.textContent || tmp.innerText || "";
  };

  // Get clean description for preview (first 120 characters)
  const descriptionPreview = stripHtmlTags(blog.description).substring(0, 120);
  const displayDescription = descriptionPreview.length === 120 
    ? descriptionPreview + "..." 
    : descriptionPreview;

  return (
    <Card
      sx={{
        backgroundColor: "#1A2E55",
        color: "#FFFFFF",
        borderRadius: "12px",
        boxShadow: "0 8px 30px rgba(0, 0, 0, 0.25)",
        transition: "transform 0.3s ease, box-shadow 0.3s ease",
        "&:hover": {
          transform: "translateY(-5px)",
          boxShadow: "0 12px 36px rgba(0, 86, 179, 0.5)",
        },
      }}
    >
      <CardActionArea>
        <LazyLoad height={220} offset={100} once>
          <CardMedia
            component="img"
            height="220"
            image={blog.image}
            alt={blog.title}
            sx={{ borderRadius: "12px 12px 0 0", objectFit: "cover" }}
          />
        </LazyLoad>
        <CardContent sx={{ padding: "20px" }}>
          <Box sx={{ marginBottom: "8px" }}>
            <Typography
              variant="caption"
              sx={{
                color: "#B0BEC5",
                fontSize: "0.8rem",
                textTransform: "uppercase",
              }}
            >
              {formattedDate}
            </Typography>
          </Box>
          <Typography
            variant="h6"
            sx={{
              fontWeight: 700,
              marginBottom: "12px",
              color: "#A9C9EA",
              letterSpacing: "0.5px",
              lineHeight: "1.2",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            {blog.title}
          </Typography>
          <Typography
            variant="body2"
            sx={{
              color: "#D1D5DB",
              marginBottom: "16px",
              overflow: "hidden",
              display: "-webkit-box",
              WebkitLineClamp: 2,
              WebkitBoxOrient: "vertical",
              textOverflow: "ellipsis",
              lineHeight: "1.5",
            }}
          >
            {displayDescription}
          </Typography>
          <Button
            variant="contained"
            onClick={() => navigate(`/news/details/${blog.id}`)}
            sx={{
              backgroundColor: "#10a7e0",
              color: "#FFFFFF",
              fontSize: "0.9rem",
              textTransform: "uppercase",
              borderRadius: "8px",
              boxShadow: "0 4px 14px rgba(0, 123, 255, 0.3)",
              "&:hover": {
                backgroundColor: "#10a7e0",
                boxShadow: "0 6px 20px rgba(0, 86, 179, 0.4)",
              },
            }}
          >
            details
          </Button>
        </CardContent>
      </CardActionArea>
    </Card>
  );
});

export default BlogCard;
